import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Notification.scss';

const Notification = ({ children, error, info, success, title, message, warning }) => {
  const classes = cn({
    [styles.notification]: true,
    'border-danger': error,
    'border-info': info,
    'border-success': success,
    'border-warning': warning
  });

  return (
    <div className={classes}>
      {title && <h4>{title}</h4>}
      {message && message}
      {children && children}
    </div>
  );
};

Notification.propTypes = {
  children: PropTypes.node,
  error: PropTypes.bool,
  info: PropTypes.bool,
  message: PropTypes.string,
  success: PropTypes.bool,
  title: PropTypes.string,
  warning: PropTypes.bool
};

Notification.defaultProps = {
  children: undefined,
  error: false,
  info: false,
  message: undefined,
  success: false,
  title: 'Oops!',
  warning: false
};

export default Notification;
